import { Divider } from '@reveni-io/reveni-ui'

import ImportCounters from '../ImportCounters/ImportCounters'
import ImportErrorsTable from '../ImportErrorsTable/ImportErrorsTable'
import ImportFileErrorAlert from '../ImportFileErrorAlert/ImportFileErrorAlert'
import ReexportedRowsAlert from '../ReexportedRowsAlert/ReexportedRowsAlert'

const ImportResultSummary = ({ result, email }) => {
  if (result.file_error) return <ImportFileErrorAlert fileError={result.file_error} />

  return (
    <>
      <ImportCounters processedRows={result.processed_rows} errorRows={result.error_rows} />
      {result.error_rows > 0 && (
        <>
          <ReexportedRowsAlert errorRows={result.error_rows} email={email} />
          <Divider />
          <ImportErrorsTable errors={result.errors} />
        </>
      )}
    </>
  )
}

export default ImportResultSummary
